function t(t){if(void 0===t)return{};const e={};return Object.keys(t).filter((e=>!(e.match(/^on[A-Z]/)&&"function"==typeof t[e]))).forEach((n=>{e[n]=t[n]})),e}export{t as default};
//# sourceMappingURL=omitEventHandlers.js.map
